import * as React from 'react'

import SearchInput from '~/client/src/shared/components/Filters/SearchInput/SearchInput'

import { useMobileResourceActions, useMobileResourceState } from '../context'

export const MobileResourceSearch: React.FC = () => {
  const { searchKey } = useMobileResourceState()
  const { setSearchKey } = useMobileResourceActions()

  return (
    <SearchInput
      value={searchKey}
      onChange={setSearchKey}
      size="lg"
      className="tw:flex-1 tw:min-w-0"
    />
  )
}
